import * as React from 'react'
import { connect } from 'react-redux'
import {Col, Container, Row} from "reactstrap";
import {ApplicationState} from "src/store";
import {
    ConfiguratorProduct,
    ProductFamilyIconsInner,
    Product, UsedMainCategoriesInner
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {
    getSelectedAlternatives, getSelectedMainCategoryData,
    getSelectedProductData,
    getSelectedSubCategoryData,
    SelectedAlternativeProduct
} from "App/services";
import {ConfiguratorOverviewPage} from "Components/ConfiguratorOverview";
import {ConfiguratorDetailPage} from "Components/ConfiguratorDetail";
import {CurrencyProps, DetailPriceProps} from "App/constants";
import {Basket} from "App/basket";
import StickyBox from "react-sticky-box";
import {UserState} from "App/user";

interface StateToProps extends CurrencyProps, DetailPriceProps {
    category: UsedMainCategoriesInner | null
    subcategory: ProductFamilyIconsInner |null
    product: Product | null
    configuration: ConfiguratorProduct | null
    alternatives: Map<number, SelectedAlternativeProduct>
    basket: Basket
}

interface ComponentStateToProps extends StateToProps {
    user: UserState|null;
}

interface DispatchToProps {
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    currency: state.currency,
    category: getSelectedMainCategoryData(state.data),
    subcategory: getSelectedSubCategoryData(state.data),
    product: getSelectedProductData(state.data),
    configuration: state.data.configuration?state.data.configuration.configuration:null,
    alternatives: getSelectedAlternatives(state.data),
    basket: state.basket,
    detailPrice: state.detailPrice
});

class _Container extends React.PureComponent<ComponentStateToProps & DispatchToProps & WithTranslation> {

    render() {
        const {configuration, category, subcategory, product, alternatives, basket, currency, detailPrice, user} = this.props;
        return <Container className="py-4 px-0 configuration">
            <Row>
                <Col className="col-12 col-xl-4 pr-lg-2 d-print-none">
                    {
                        configuration&&category&&subcategory&&product?
                        <StickyBox offsetTop={20} offsetBottom={20}>
                            <ConfiguratorOverviewPage currency={currency} subcategory={subcategory}
                                                      configuration={configuration} product={product} basket={basket} user={user}/>
                        </StickyBox>
                        :null
                    }
                </Col>
                <Col className="col-12 col-xl-8 pl-lg-2 pt-3 pt-lg-0 col-print-w100">
                    {
                        configuration&&category&&subcategory&&product?
                        <ConfiguratorDetailPage currency={currency} category={category} subcategory={subcategory}
                                                configuration={configuration} product={product} alternatives={alternatives}
                                                basket={basket} detailPrice={detailPrice} user={user}/>
                        :null
                    }
                </Col>
            </Row>
        </Container>
    }
}

export const ConfigurationPage = connect(mapStateToProps, null)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/ConfigurationPage.tsx